import { createApp } from "vue";
import VConsole from "vconsole";

import App from "./App.vue";

import { setupRouter } from "@/router";

import { setupStore } from "@/stores";

import { setupI18n } from "@/locales";

import { setupVant } from "./plugins/vant";
import { initInject } from "@hellotalk/skeleton/client/index";

import { initAppConfig } from "@/logics/init-app-config";
import { initWebviewHook } from "@/logics/init-webview-hook";
import { initThinkingData } from "@/logics/init-thinkingdata";
import { initSentry } from "@/utils/init-sentry";
import { useDarkMode } from "@/logics/init-dark-mode";

import "vant/lib/index.css";

import "@ht/styles/variables.less";
import "@ht/styles/fonts.css";
import "@ht/styles/variables.less";
import "@hellotalk/skeleton/style/skeleton.less";

async function bootstrap() {
  console.log("main -> bootstrap函数初始化1");

  // 正式环境外或者链接带有'vConsole'参数才引入VConsole
  if (!__PROD__ || /vConsole/.test(location.href)) {
    new VConsole();
  }

  const app = createApp(App);

  setupStore(app);

  setupRouter(app);

  setupVant(app);

  initWebviewHook();

  useDarkMode();

  // 初始化用户信息，App配置等
  await initAppConfig();

  // 初始化埋点
  initThinkingData();

  await setupI18n(app);

  // 开发环境下才注入生成骨架屏的按钮
  if (__LOCAL__) {
    setTimeout(initInject);
  }
  // 接入sentry监控
  app.use(initSentry);
  app.mount("#app");
}

bootstrap();

// trigger build
/**
 * Android Debug
 * 使用 `__HT_SELECT_WORD__` 类名触发点词翻译。
 */
// const loadScript = async () => {
//   const script = document.createElement("script");
//   script.src = "../click_trans_web.js";
//   document.body.appendChild(script);
// };
// setTimeout(loadScript, 2000);
